<p-dialog
  #infoSettings
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center">
      <i [class]="data.icon ?? 'pi pi-fw pi-cog text-primary'"></i>
      <span class="font-light fs-normal ml-1">
        {{ data.titulo }}
      </span>
    </div>
  </ng-template>
  <h6
    class="mb-2 font-weight-light"
    [style]="data.breakline ? 'white-space: pre;' : 'white-space: normal;'"
    *ngIf="data.bodyMessage"
  >
    {{ data.bodyMessage }}
  </h6>
  <div *ngFor="let msg of data.regras" class="flex flex-column">
    <div class="flex align-items-center mt-2">
      <mat-icon color="primary" class="mr-1">info</mat-icon>
      <span>{{ msg.regra }}</span>
    </div>
    <div class="flex flex-column mt-1">
      <p class="fs-small text-justify">{{ msg.descricao }}</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="mt-2 justify-content-center">
      <button mat-flat-button color="primary" mat-dialog-close>
        Entendi
      </button>
    </div>
  </ng-template>
</p-dialog>
